import { render, staticRenderFns } from "./gSelect.vue?vue&type=template&id=3e853402&"
import script from "./gSelect.vue?vue&type=script&lang=js&"
export * from "./gSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gSelect.vue"
export default component.exports